<template>
  <div v-if="survey" ref="scrollparent">

    <!-- breadcrumbs -->
    <v-divider></v-divider>
      <v-layout ma-0 py-1 class="d-flex align-center justify-end">
        <v-tooltip top>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" text small @click="changeGrid">
              <v-icon color="primary">dashboard</v-icon>
            </v-btn>
          </template>
          <span>{{ $t("edit-audit-screen.change-view") }}</span>
        </v-tooltip>
      </v-layout>
    <v-divider></v-divider><!-- breadcrumbs -->
    
    <v-row wrap class="mt-5 mt-md-8">
      <!-- Sticky col -->
      <v-col
        cols="12"
        md="5"
        order-md="2"
        v-scroll="onScroll"
        ref="sticky"
        class="sticky-nav">
        <SubmitAudit
          :answerid="$route.params.answerid"
          :survey="survey"
          :firm="firm"
          class="mb-5"></SubmitAudit>

        <div class="box">
          <v-layout
            d-block
            d-md-flex
            row
            ma-0
            align-center
            justify-space-between
            class="box-header px-5 px-md-6"
          >
            <h3>{{ $t("edit-audit-screen.navigation-box-title") }}</h3>
          </v-layout>
          <div class="box-content flex px-6 px-md-8">
            <div
              v-for="sequence in survey.sequences"
              :key="sequence.id"
              class="flex row align-center justify-space-between"
            >
              <span class="row ma-0 mb-4 mb-md-0 pa-0">
                <v-icon
                  size="15px"
                  class="col-1 mr-2"
                  color="secondary">icon-directory</v-icon>
                <button
                  class="subtitle-1 link pa-0 pa-md-2 mb-1 col-10 text-left"
                  @click="$vuetify.goTo(`#${makeId(sequence[`title_${$i18n.locale}`])}`)"
                  v-html="sequence[`title_${$i18n.locale}`]"
                ></button>
              </span>
              <!-- <small>Max. {{  }}</small> -->
            </div>
          </div>
        </div>
      </v-col><!-- Sticky col --><!-- Sticky col -->

      <!-- Display Sequences and the question to it -->
      <v-col cols="12" md="7">
        <transition-group name="fade">
          <div
            v-for="(sequence, index) in survey.sequences"
            :key="`sequences-${index}`"
            class="mb-12"
            :id="makeId(sequence[`title_${$i18n.locale}`])"
          >
            <SequenceBox
              :answerid="$route.params.answerid"
              :sequence="sequence"
              :maxDerogations="parseInt(survey.total.maxderogations)"
              :doneDerogations="parseInt(survey.done.derogations)"
              @updateAllSeq="updateSequence"
              @updateSubmitBtn="refreshSubmitBtn"
              showQuestion
              onlyTask
              :status="survey.info.status"
              class="mb-8"
            ></SequenceBox>

          </div>
        </transition-group>
      </v-col><!-- Display Sequences and the question to it -->
    </v-row>
  </div>
</template>

<script>
import { getFirm } from '@/js/firm/getFirm'
// import IDCard from '@/components/firm/IDCard'
import SequenceBox from '@/components/audits/survey/SequenceBox'
import SubmitAudit from '@/components/audits/SubmitAudit'

export default {
  components: {
    // IDCard: IDCard,
    SequenceBox: SequenceBox,
    SubmitAudit: SubmitAudit
  },

  props: {
    survey: Array | Object,
    firm: Array | Object
  },

  data () {
    return {
      offsetTop: 0,
      isActive: false
      // renderComponent: true
    }
  },

  // async mounted () {
  //   await this.$nextTick(() => {
  //     this.initScroll()
  //   })
  // },

  methods: {
    makeId (value) {
      return value.replace(/\W/g,'_')
    },
    changeGrid () { this.$emit('changeGridViews') },

    onScroll () {
      if (this.$vuetify.breakpoint.name === 'xs' ||
          this.$vuetify.breakpoint.name === 'sm') {

        this.$refs.sticky.style.transform = 'translateY(0px)'
        return
      }
      // this.offsetTop = e.target.scrollTop
      const sticky = this.$refs.sticky
      const offsetTop = window.pageYOffset || document.documentElement.scrollTop

      if (offsetTop > sticky.offsetTop) {
        // console.log(this.$refs.scrollparent.offsetTop)
        if (((offsetTop - sticky.offsetTop - 100) + sticky.offsetHeight) >= (this.$refs.scrollparent.offsetHeight - 100)) return
        // (offsetTop - sticky.offsetTop - 100) + 
        sticky.style.transform = `translateY(${offsetTop - sticky.offsetTop - 100}px)`
      }
      else {
        sticky.style.transform = 'translateY(0px)'
      }
    },
    // forceRerender() {
    //   // Remove my-component from the DOM
    //   this.renderComponent = false
      
    //   this.$nextTick(() => {
    //     // Add the component back in
    //     this.renderComponent = true
    //   })
    // },

    updateSequence () { this.$emit('updateSeq') },

    refreshSubmitBtn () {
      this.$emit('reloadSubmitBtn')
    },

    initScroll () {
      if (this.$route.params.tab &&
          this.$route.params.tab[`title_${this.$i18n.locale}`] !== '' &&
          this.$route.params.tab[`title_${this.$i18n.locale}`] !== null &&
          this.$route.params.tab[`title_${this.$i18n.locale}`] !== 'null' &&
          this.$route.params.tab[`title_${this.$i18n.locale}`] !== undefined &&
          this.$route.params.tab[`title_${this.$i18n.locale}`] !== 'undefined') {

      this.$vuetify.goTo(`#${this.makeId(this.$route.params.tab[`title_${this.$i18n.locale}`])}`)
      }
    }
  }
}
</script>
